import React from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';

//import { colorList } from './chartDef';

class Pie extends React.Component {

    state = {
        domId: "chart_pie_" + new Date().getTime(),
        chart: null
    }

    componentDidMount() {
        // 初始化
        // let chart = echarts.init(document.getElementById(this.state.domId));
        // this.setState({ chart: chart });
        window.addEventListener("resize", this.handleResize, false);
    }
    componentWillUnmount() {
        //一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener("resize", this.handleResize, false);
      }
    handleResize = (e) => {
        this.state.chart.resize();
    };

    componentWillReceiveProps(nextProps) {
        this.refreshChart(nextProps);
      }

      refreshChart(props) {
        let { data, title,subtext, legendShow, labelShow, labelFormatter, legendData} = props;
        //项目排列
        let legend = {
            data: legendData,
            x: 'left',//'center'
            y: 'top',//'bottom'
            orient: 'vertical',
            // orient: 'horizontal'
        };

        let series = []
        let item = {
            data: data,
            type: 'pie',
            radius: '60%',
            itemStyle:{
                normal:{
                        //饼图的文字和位置
                        label:{
                            show: labelShow===false?false:true,
                            formatter: labelFormatter===null||labelFormatter===undefined?'{b}({d}%)':labelFormatter,
                            //position: 'inside',
                            //color:'#fff'
                        },
                        labelLine :{
                            show:labelShow===false?false:true
                        }
                }
            },
        };
        series.push(item)
        
        let option = {
            //color: colorList,
            title: {
                text: title,
                x: 'center',   //位置
                subtext: subtext,
                subtextStyle: {
                    color: '#000000',
                    fontSize: 12 ,
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: "{b} : {c} ({d}%)"
            },
            legend: legendShow === false ? null : legend,
            grid: {
                left: '2%',
                right: '5%',
                bottom: '3%',
                containLabel: true
            },
            calculable: true,
            series: series
        };
        if (this.state.chart != null) {
            this.state.chart.setOption(option);
        }
        if (this.state.chart == null) {
            let chart = echarts.init(document.getElementById(this.state.domId));
            this.setState({ chart: chart });
            chart.setOption(option);
        } else {
            this.state.chart.setOption(option);
        }
    }

    render() {
        return (
            <div id={this.state.domId} 
            style={{ width: '100%', height: '100%' }}></div>
        );
    }
}

export default Pie;